import React from 'react';
import PropTypes from 'prop-types';
import {EVENT_MEDIA_STATUS} from './eventMediaConstants';

export default class EventMediaPreloaderUnderlay extends React.PureComponent {

    render() {

        switch (this.props.status) {
            case EVENT_MEDIA_STATUS.ERROR: // DEPRECATED_VIDEO_PREVIEW_REQUEST
            case EVENT_MEDIA_STATUS.ERROR_REQUEST_TIMEOUT:
            case EVENT_MEDIA_STATUS.ERROR_UPLOAD_FAILED:
            case EVENT_MEDIA_STATUS.ERROR_SHORT_FAILED:
            case EVENT_MEDIA_STATUS.ERROR_RECORDING_FAIL:
            case EVENT_MEDIA_STATUS.ERROR_DOWNLOAD_FAILED:
            case EVENT_MEDIA_STATUS.ERROR_MEDIA_FAILED:
            case EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE:
            case EVENT_MEDIA_STATUS.SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE:
                return null;
            default:
                break;
        }
        return (
            <div className="event-media-preloader-underlay">
                <div className="event-media-preloader-underlay-subheader"><div className="pending-branded"><div className="loading-activity-indicator"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>
            </div>
        )
    }
}

EventMediaPreloaderUnderlay.propTypes = {
    status: PropTypes.string.isRequired
};
